import { NgModule } from '@angular/core';
import { SafeUrlPipe } from './safe-url.pipe';
import { LoopPipe } from './loop.pipe';
import { KeysLoopPipe } from './keys-loop.pipe';
import { PercentagePipe } from './percentage.pipe';
import {ToFixedPipe} from './to-fixed.pipe';
import { TranslationPipe } from './translation.pipe';
import { HttpClientModule } from '@angular/common/http';
import { ImagePreloadDirective } from '../directives/imagePreload.directive';
import { QuestionGroupAttributesPipe } from './question-group-attributes.pipe';
import { QuestionAttributesPipe } from './question-attributes.pipe';
import { InverseQuestionAttributePipe } from './inverse-question-attribute.pipe';
import { QuestionAttributePipe } from 'src/app/shared/pipes/question-attribute.pipe';

@NgModule({
  declarations: [	
    SafeUrlPipe,
    LoopPipe,
    KeysLoopPipe,
    PercentagePipe,
    TranslationPipe,
    ImagePreloadDirective,
    QuestionGroupAttributesPipe,
    QuestionAttributesPipe, 
    QuestionAttributePipe,
    InverseQuestionAttributePipe,
    ToFixedPipe
   ],
  imports: [
    HttpClientModule
  ],
  exports: [
    SafeUrlPipe,
    LoopPipe,
    KeysLoopPipe,
    PercentagePipe,
    TranslationPipe,
    ImagePreloadDirective,
    QuestionGroupAttributesPipe,
    QuestionAttributesPipe,
    QuestionAttributePipe,
    InverseQuestionAttributePipe,
    ToFixedPipe
  ],
  providers: [
    QuestionGroupAttributesPipe,
    QuestionAttributesPipe,
    QuestionAttributePipe,
    InverseQuestionAttributePipe
  ]
})
export class PipesModule { }
